export default "__VITE_ASSET__7wv0qEp8__"